module.exports = __webpack_public_path__ + "static/img/2.4.16393e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/upload/picture/2.4.jpg
// module id = iAHr
// module chunks = 7